module.exports = __webpack_public_path__ + "img/vbet_logo_main.280c4419.png";